import React, { useState, useRef, useCallback, useEffect } from 'react';
import { getSpaceSite, getReservationsForSiteAvailibility, checkOut, getCampers, getSpaces, makeReservation, updateReservationDateSite, getEmailTemplates, getEmails, sendMail, occupancyReportForSiteAvailibility } from '../utils/OpenCampground_Database_Calls';
import QueryString from "query-string";
import './CampgroundCalendar.css';
import { format } from 'date-fns';
import { useLocation } from "react-router-dom";
import { CircularProgress } from '@material-ui/core';
import View from './viewReservation';

function formatLocalDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
function toUTCDateOnly2(dateString) {
        const date = new Date(dateString);
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}


function getDuration(checkIn, checkOut) {
    const startDate = toUTCDateOnly2(checkIn);
    const endDate = toUTCDateOnly2(checkOut);
    let months = 0, weeks = 0, days = 0; 
    let tempDate = new Date(startDate);

    while (true) {
        const nextMonth = new Date(Date.UTC(tempDate.getUTCFullYear(), tempDate.getUTCMonth() + 1, tempDate.getUTCDate()));
        if (nextMonth <= endDate) {
            months++;
            tempDate = nextMonth;
        } else {
            break;
        }
    }

    const remainingDays = Math.floor((endDate - tempDate) / (24 * 60 * 60 * 1000));
    weeks = Math.floor(remainingDays / 7);
    days = remainingDays % 7;

    return [days, weeks, months];
}

const NotificationModal = ({ type, reservationData, onClose }) => (
  <div className="modal-overlay">
    <div className={`modal-content notification-modal ${type}-modal`}>
        <div className="modal-header">
            <h2>{type == 'success' ? 'Reservation Summary': 'Failed'}</h2>
            <button onClick={onClose} className="close-button">
                <X size={20} />
            </button>
        </div>
      
      
      <p style={{marginTop:'3%'}}>{type == 'success' ? 'Reservation Created with' : 'Reservation Failed'}</p>
      
      
      {type === 'success' && reservationData && (
        <div className="reservation-details success-details">
          <p><strong>Reservation Number:</strong> {reservationData.id}</p>
        </div>
      )}
      
      {/* <div className="button-group">
        {type === 'success' ? (
          null
        ) : (
          <>
            <button onClick={onClose} className="secondary-button">
              Cancel
            </button>
          </>
        )}
      </div> */}
      <div className="button-group" style={{display:'flex', justifyContent:'flex-end'}}>
        <button onClick={onClose} className="secondary-button" style={{width:'20%', border:'none', backgroundColor:'rgb(253, 236, 235)', color:'rgb(219, 55, 55)', padding:'2% 3%', cursor:'pointer'}}>
            Cancel
        </button>
      </div>
    </div>
  </div>
);

const ReservationConflictnModal = ({ onClose }) => (
  <div className="modal-overlay">
    <div className={`modal-content notification-modal`}>
        <div className="modal-header">
            <h3>Dates Conflict</h3>
            <button onClick={onClose} className="close-button">
                <X size={20} />
            </button>
        </div>
      
      
      <p style={{marginTop:'3%'}}>Cannot move here - dates conflict with existing reservation</p>
      
      
      <div className="button-group" style={{display:'flex', justifyContent:'flex-end'}}>
        <button onClick={onClose} className="secondary-button" style={{width:'20%', border:'none', backgroundColor:'rgb(253, 236, 235)', color:'rgb(219, 55, 55)', padding:'2% 3%', cursor:'pointer'}}>
            Cancel
        </button>
      </div>
    </div>
  </div>
);

const InstantBookModal = ({ onClose, onSave }) => {
    const location = useLocation();
    const params = QueryString.parse(location.search);
    const serverName = params.serverName;
    const [cost, setCost] = useState(0);
    const [formData, setFormData] = useState({
        startDate: "",
        endDate: "",
        space: "",
        guest: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        address: "",
        guestId: "",
        internalNotes: ""
    });
    const [duration, setDuration] = useState({
        months: 0,
        weeks: 0,
        days: 0,
    });

    const [spaces, setSpaces] = useState([]);
    const [guests, setGuests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingSpaces, setLoadingSpaces] = useState(true);
    const [mailMessages, setMailMessages] = useState([]);
    const [email, setEmail] = useState();

    // Fetch guests on mount
    useEffect(() => {
        const fetchGuests = async () => {
        try {
            const res = await getCampers('',serverName);
            const mailMessagesRes = await getEmailTemplates("",serverName);
            const email = await getEmails("", serverName)
            setGuests(res);
            setLoading(false);
            setMailMessages(mailMessagesRes);
            setEmail(email);
        } catch (err) {
            console.error("Error fetching guests:", err);
        }
        };
        fetchGuests();
    }, []);

        // Fetch spaces when startDate and endDate are set
    useEffect(() => {
        if (formData.startDate && formData.endDate) {
            console.log("Fetching spaces for dates:", formData.startDate, formData.endDate);
            
            let inDate = formData.startDate;
            let outDate = formData.endDate;
            const fetchSpaces = async () => {
                try {
                const data = await getSpaces('', serverName, outDate, inDate);
                setSpaces(data);
                setLoadingSpaces(false);
                } catch (err) {
                console.error("Error fetching spaces:", err);
                }
            };
        fetchSpaces();
        }
    }, [formData.startDate, formData.endDate]);

        // Handle field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name === 'space'){
            console.log(value); //getting [object Object]
            const selectedSpace = spaces.find((s) => s.id == value);
            console.log("Selected space object:", selectedSpace);  
            
            const term = getDuration(formData.startDate,formData.endDate);
            console.log("Calculated term (days, weeks, months):", term);
            
            let cost = 0;
            cost += term[0] * selectedSpace.daily_rate;
            cost += term[1] * selectedSpace.weekly_rate;
            cost += term[2] * selectedSpace.monthly_rate;
            console.log("Selected space:", selectedSpace.space_name, "Cost calculated:", cost);
            setCost(cost);
            setFormData((prev) => ({ ...prev, [name]: value }));
            setDuration({days: term[0], weeks: term[1], months: term[2]});
        }
        else
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const selectedSpace = spaces.find(s => s.id ==formData.space);
    console.log(selectedSpace,'selected space');
    

    // When guest is selected, populate details
    const handleGuestSelect = (e) => {
        const guestId = e.target.value;
        console.log("Selected guest ID:", guestId);
        if (guestId) {
        const selectedGuest = guests.find((g) => g.id == guestId);
        if (selectedGuest) {
            console.log(selectedGuest);
            
            setFormData((prev) => ({
            ...prev,
            firstName: selectedGuest.first_name || "",
            lastName: selectedGuest.last_name || "",
            phone: selectedGuest.phone || "",
            email: selectedGuest.email || "",
            address: selectedGuest.address || "",
            guestId: selectedGuest.id || "",
            guest: selectedGuest.id || ""
            }));
        }
        } else {
        // reset guest info if none selected
        setFormData((prev) => ({
            ...prev,
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            address: "",
        }));
        }
    };

    const sendReservationConfirmationMail = async (reservationId) => {
        let mailmessage = replaceMailTemplatePlaceHolders(reservationId)
        let mailResponse = await sendMail("", serverName, email.sender, formData.email, email.confirm_subject, mailmessage, email.reply, email.cc, email.bcc, mailMessages[0].attachments)
    }

    const replaceMailTemplatePlaceHolders = (reservationId) => {
        let mailMessage = mailMessages[0].body
        mailMessage = mailMessage.replace('{{camper}}', formData.firstName + ' ' + formData.lastName);
        mailMessage = mailMessage.replace('{{space_name}}', selectedSpace.space_name);
        mailMessage = mailMessage.replace('{{number}}', reservationId);
        mailMessage = mailMessage.replace('{{created}}', format(new Date(), 'yyyy-MM-dd HH:mm:ss'));
        mailMessage = mailMessage.replace('{{start}}', formData.startDate);
        mailMessage = mailMessage.replace('{{departure}}', formData.endDate);
        mailMessage = mailMessage.replace('{{charges}}', cost);
        mailMessage = mailMessage.replace('{{payment}}', 0);
        mailMessage = mailMessage.replace('{{due}}', cost);
        mailMessage = mailMessage.replace('{{deposit}}', 0);
        return mailMessage
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const res = await makeReservation("",serverName,formData.lastName,formData.firstName,formData.address,"","","",formData.phone,formData.email,2,formData.space,"",formData.startDate,formData.endDate,0,0,0,formData.adults,0,cost,format(new Date(), 'yyyy-MM-dd HH:mm:ss'),0,0,formData.internalNotes,0,formData.guestId,0,0,0)
            sendReservationConfirmationMail(res.insertId)
            onSave(formData, "success", res.insertId, cost)
        } catch (error) {
            onSave(formData, "failed", 0);
        }
        
    };
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Instant Book</h2>
                    <button onClick={onClose} className="close-button">
                        <X size={20} />
                    </button>
                </div>
                <div className="modal-body instant-book-body">
                            <div className="booking-form">
                                {/* Guest Profile Selection */}
                                <div className="form-section">
                                    <h3 className="section-title">Guest Profile</h3>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Existing Guest Profile</label>
                                            <select
                                                value={formData.guest}
                                                onChange={handleGuestSelect}
                                                className="form-input"
                                            >
                                                <option value="">{loading?"Loading Guests":"Select existing guest or create new"}</option>
                                                {guests.map(guest => (
                                                    <option key={guest.id} value={guest.id}>
                                                        {guest.first_name} {guest.last_name} - {guest.email}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Guest Information */}
                                <div className="form-section">
                                    <h3 className="section-title">Guest Information</h3>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>First Name *</label>
                                            <input
                                                type="text"
                                                value={formData.firstName}
                                                onChange={(e) => setFormData({...formData, firstName: e.target.value, guestId: ''})}
                                                className={`form-input`}
                                                placeholder="Enter first name"
                                            />
                                            {/* {errors.firstName && <span className="error-message">{errors.firstName}</span>} */}
                                        </div>
                                        <div className="form-group">
                                            <label>Last Name *</label>
                                            <input
                                                type="text"
                                                value={formData.lastName}
                                                onChange={(e) => setFormData({...formData, lastName: e.target.value, guestId: ''})}
                                                className={`form-input`}
                                                placeholder="Enter last name"
                                            />
                                            {/* {errors.lastName && <span className="error-message">{errors.lastName}</span>} */}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input
                                                type="email"
                                                value={formData.email}
                                                onChange={(e) => setFormData({...formData, email: e.target.value, guestId: ''})}
                                                className="form-input"
                                                placeholder="guest@email.com"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Phone Number</label>
                                            <input
                                                type="tel"
                                                value={formData.phone}
                                                onChange={(e) => setFormData({...formData, phone: e.target.value, guestId: ''})}
                                                className="form-input"
                                                placeholder="(555) 123-4567"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Reservation Details */}
                                <div className="form-section">
                                    <h3 className="section-title">Reservation Details</h3>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Check In *</label>
                                            <input
                                                type="date"
                                                value={formData.startDate}
                                                onChange={(e) => setFormData({...formData, startDate: e.target.value})}
                                                className={`form-input`}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                            {/* {errors.checkIn && <span className="error-message">{errors.checkIn}</span>} */}
                                        </div>
                                        <div className="form-group">
                                            <label>Check Out *</label>
                                            <input
                                                type="date"
                                                value={formData.endDate}
                                                onChange={(e) => setFormData({...formData, endDate: e.target.value})}
                                                className={`form-input`}
                                                min={ formData.startDate ? new Date(new Date(formData.startDate).setDate(new Date(formData.startDate).getDate() + 1)).toISOString().split("T")[0] : new Date().toISOString().split("T")[0] }
                                            />
                                            {/* {errors.checkOut && <span className="error-message">{errors.checkOut}</span>} */}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Site *</label>
                                            <select
                                                value={formData.space}
                                                onChange={handleChange}
                                                disabled={!formData.startDate || !formData.endDate}
                                                name='space'
                                                className={`form-input`}
                                            >
                                                <option value="">{loadingSpaces?"Loading Available Spaces":"Select a Space"}</option>
                                                {spaces.map(space => (
                                                    <option key={space.id} value={space.id}>
                                                        {space.space_name} - {space.sitetype_name} (${space.daily_rate}/night)
                                                    </option>
                                                ))}
                                            </select>
                                            {/* {errors.siteId && <span className="error-message">{errors.siteId}</span>} */}
                                        </div>
                                    </div>
                                </div>

                                {/* Party Details - NO PETS */}
                                <div className="form-section">
                                    <h3 className="section-title">Party Details</h3>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Adults</label>
                                            <select
                                                value={formData.adults}
                                                onChange={(e) => setFormData({...formData, adults: parseInt(e.target.value)})}
                                                className="form-input"
                                            >
                                                {[1,2,3,4,5,6,7,8].map(num => (
                                                    <option key={num} value={num}>{num}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Children</label>
                                            <select
                                                value={formData.children}
                                                onChange={(e) => setFormData({...formData, children: parseInt(e.target.value)})}
                                                className="form-input"
                                            >
                                                {[0,1,2,3,4,5,6].map(num => (
                                                    <option key={num} value={num}>{num}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Additional Options */}

                                {/* Payment & Deposit */}

                                {/* Internal Notes */}
                                <div className="form-section">
                                    <h3 className="section-title">Internal Notes</h3>
                                    <div className="form-group">
                                        <label>Notes</label>
                                        <textarea
                                            value={formData.internalNotes}
                                            onChange={(e) => setFormData({...formData, internalNotes: e.target.value})}
                                            className="form-textarea"
                                            rows="3"
                                            placeholder="Internal staff notes..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Booking Summary Sidebar - NO PETS */}
                            <div className="booking-summary">
                                <h3 className="summary-title">Booking Summary</h3>
                                
                                {selectedSpace && (
                                    <div className="summary-content">
                                        <div className="summary-item">
                                            <span className="label">Space:</span>
                                            <span className="value">{selectedSpace.space_name}</span>
                                        </div>
                                        <div className="summary-item">
                                            <span className="label">Site:</span>
                                            <span className="value">{selectedSpace.sitetype_name}</span>
                                        </div>
                                        <div className="summary-item">
                                            <span className="label">Rate:</span>
                                            <span className="value">${selectedSpace.daily_rate}/night</span>
                                        </div>
                                        
                                        {formData.startDate && formData.endDate && (
                                            <>
                                                <div className="summary-divider"></div>
                                                <div className="summary-item">
                                                    <span className="label">Check-in:</span>
                                                    <span className="value">{formData.startDate}</span>
                                                </div>
                                                <div className="summary-item">
                                                    <span className="label">Check-out:</span>
                                                    <span className="value">{formData.endDate}</span>
                                                </div>
                                                {duration.months>0 && <div className="summary-item">
                                                    <span className="label">Months:</span>
                                                    <span className="value">{duration.months}</span>
                                                </div>}
                                                {duration.weeks>0 && <div className="summary-item">
                                                    <span className="label">Weeks:</span>
                                                    <span className="value">{duration.weeks}</span>
                                                </div>}
                                                {duration.days>0 && <div className="summary-item">
                                                    <span className="label">Nights:</span>
                                                    <span className="value">{duration.days}</span>
                                                </div>}
                                                
                                                <div className="summary-divider"></div>
                                                <div className="summary-item">
                                                    <span className="label">Subtotal:</span>
                                                    <span className="value">${cost}</span>
                                                </div>
                                                {/* <div className="summary-total">
                                                    <span className="label">Total:</span>
                                                    <span className="value">$</span>
                                                </div> */}
                                                
                                            </>
                                        )}
                                        
                                        {(formData.adults > 0 || formData.children > 0) && (
                                            <>
                                                <div className="summary-divider"></div>
                                                <div className="summary-item">
                                                    <span className="label">Party:</span>
                                                    <span className="value">
                                                        {formData.adults} adults
                                                        {formData.children > 0 && `, ${formData.children} children`}
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                                
                                <div className="summary-actions">
                                    <button
                                        onClick={handleSubmit}
                                        className="book-now-button"
                                        disabled={!formData.firstName || !formData.lastName || !formData.space || !formData.startDate || !formData.endDate}
                                    >
                                        Book Now
                                    </button>
                                    <button
                                        onClick={onClose}
                                        className="cancel-book-button"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
            </div>
        </div>
    );
};


const X = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="m18 6-12 12" />
        <path d="m6 6 12 12" />
    </svg>
);
        
const Plus = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M5 12h14" />
        <path d="M12 5v14" />
    </svg>
);

        const CampgroundCalendar = ({onClose}) => {
            const [sites, setSites] = useState([
            ]);
            const [siteTypes, setSiteTypes] = useState([]);
            const [loading, setLoading] = useState(true);
            const [view, setView] = useState(false);
            const [conflictState, setConflictState] = useState({
                hasConflict: false,
                message: ''
            });

            const [visualDragState, setVisualDragState] = useState({
                draggedReservationId: null,
                visualPosition: null
            });

            const [reservations, setReservations] = useState([
            ]);

            const [kpi, setKpi] = useState({
                occupancyRate: 0,
                totalRevenue: 0,
            });
            const [update, setUpdate] = useState(false);

            const fetchReservations = async () => {
                try {
                const res = await getSpaceSite(serverName);
                let reservations = await getReservationsForSiteAvailibility(serverName);
                reservations = reservations.body.map(r => ({
                    ...r,
                    checkIn: new Date(r.checkIn.split('T')[0] + 'T00:00:00'),
                    checkOut: new Date(r.checkOut.split('T')[0] + 'T00:00:00'),
                }));
                console.log(reservations);
                
                setReservations(reservations);
                const data = res.body;                
                setSites(data[0]);
                setSiteTypes(data[1]);
                setLoading(false);
                console.log(data);
                
                } catch (error) {
                console.error("Error fetching reservations:", error);
                }
            };

            const fetchKPI = async () => {
                try {
                let data = await occupancyReportForSiteAvailibility(serverName);
                data = data.body;
                setKpi({ occupancyRate: data.averageOccupancy, totalRevenue: data.totalRevenue.toFixed(2) });
                
                } catch (error) {
                console.error("Error fetching KPI:", error);
                }
            };

            useEffect(() => {
                fetchReservations();
            }, [update]); 

            useEffect(() => {
                fetchKPI();
            }, []); 

            const [filters, setFilters] = useState({
                siteType: 'all',
                currentDate: new Date(),
                viewType: 'year'
            });

            const [modals, setModals] = useState({
                editReservation: null,
                instantBook: false,
                changeConfirmation: null,
                notification: null,
                message: '',
                reservationData: null,
                conflict: false
            });

            const [dragState, setDragState] = useState({
                isDragging: false,
                reservationId: null,
                dragType: null,
                startX: 0,
                startY: 0,
                originalReservation: null,
                targetSiteId: null
            });

            const calendarRef = useRef(null);
            const dayWidth = 70;
            const rowHeight = 80;

            const generateDates = () => {
                const dates = [];
                const start = new Date(filters.currentDate);
                
                switch (filters.viewType) {
                    case 'month':
                        start.setDate(1);
                        const daysInMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
                        for (let i = 0; i < daysInMonth; i++) {
                            const date = new Date(start);
                            date.setDate(i + 1);
                            dates.push(date);
                        }
                        break;
                    case 'year':
                        const yearStart = new Date(start.getFullYear(), 0, 1);
                        const yearEnd = new Date(start.getFullYear(), 11, 31);
                        const currentDate = new Date(yearStart);
                        while (currentDate <= yearEnd) {
                            dates.push(new Date(currentDate));
                            currentDate.setDate(currentDate.getDate() + 1);
                        }
                        break;
                    default:
                        start.setDate(1);
                        const defaultDaysInMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
                        for (let i = 0; i < defaultDaysInMonth; i++) {
                            const date = new Date(start);
                            date.setDate(i + 1);
                            dates.push(date);
                        }
                }
                return dates;
            };

            const dates = generateDates();
            const today = new Date();

            // const getDaysFromStart = (date) => {
            //     const startDate = dates[0];
            //     const diffTime = date.getTime() - startDate.getTime();
            //     return Math.floor(diffTime / (1000 * 60 * 60 * 24));
            // };
            // const getDaysFromStart = (date) => {
            //     const startDate = dates[0];
            //     const diffTime = date.getTime() - startDate.getTime();
            //     const daysDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            //     return daysDiff;
            // };
            // const getDaysFromStart = (date) => {
            //     if (!date || !dates[0]) return -1;
                
            //     const startDate = new Date(dates[0]);
            //     startDate.setHours(0, 0, 0, 0);
                
            //     const checkDate = new Date(date);
            //     checkDate.setHours(0, 0, 0, 0);
                
            //     const diffTime = checkDate.getTime() - startDate.getTime();
            //     const daysDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                
            //     return daysDiff;
            // };
            const getDaysFromStart = (date) => {
                if (!date || !dates[0]) return -1;
                
                // Create new date objects and set time to midnight to avoid timezone issues
                const startDate = new Date(dates[0].getFullYear(), dates[0].getMonth(), dates[0].getDate());
                const checkDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                
                const diffTime = checkDate.getTime() - startDate.getTime();
                const daysDiff = Math.round(diffTime / (1000 * 60 * 60 * 24));
                
                return daysDiff;
            };
            const isReservationInCurrentPeriod = (reservation) => {
                const viewStart = dates[0];
                const viewEnd = dates[dates.length - 1];
                
                // Check if reservation overlaps with current view period
                return reservation.checkIn <= viewEnd && reservation.checkOut >= viewStart;
            };

            const getDateFromDays = (days) => {
                const startDate = dates[0];
                const newDate = new Date(startDate);
                newDate.setDate(startDate.getDate() + days);
                return newDate;
            };

            // const getReservationPosition = (reservation) => {
            //     const startDays = getDaysFromStart(reservation.checkIn);
            //     const endDays = getDaysFromStart(reservation.checkOut);
            //     return {
            //         left: Math.max(0, (startDays) * dayWidth),
            //         width: Math.max(dayWidth, (endDays - startDays) * dayWidth)
            //     };
            // };
            // const getReservationPosition = (reservation) => {
            //     const startDays = getDaysFromStart(reservation.checkIn);
            //     const endDays = getDaysFromStart(reservation.checkOut);
            //     const maxDays = dates.length;
                
            //     // Clamp positions to calendar boundaries
            //     // const clampedStartDays = filters.viewType ==='month' ? Math.max(0, Math.min(startDays, maxDays - 1))+ 1 : Math.max(0, Math.min(startDays, maxDays - 1));
            //     // const clampedEndDays = filters.viewType ==='month' ? Math.max(clampedStartDays + 1, Math.min(endDays, maxDays))+ 1 : Math.max(clampedStartDays + 1, Math.min(endDays, maxDays));
            //     const clampedStartDays = Math.max(0, Math.min(startDays, maxDays - 1));
            //     const clampedEndDays = Math.max(clampedStartDays + 1, Math.min(endDays, maxDays));
                
            //     return {
            //         left: (clampedStartDays * dayWidth),
            //         width: Math.max(dayWidth, (clampedEndDays - clampedStartDays) * dayWidth)
            //     };
            // };
            // const getReservationPosition = (reservation) => {
            //     const viewStart = dates[0];
            //     const viewEnd = dates[dates.length - 1];
                
            //     // Use the actual reservation dates for calculation
            //     const startDays = getDaysFromStart(reservation.checkIn);
            //     const endDays = getDaysFromStart(reservation.checkOut);
                
            //     // Only clamp if the reservation extends beyond the current view
            //     const clampedStartDays = Math.max(0, startDays);
            //     const clampedEndDays = Math.min(endDays, dates.length);
                
            //     // If reservation is completely outside the view, don't render it
            //     if (clampedEndDays <= 0 || clampedStartDays >= dates.length) {
            //         return { left: -9999, width: 0 }; // Move it off-screen
            //     }
                
            //     return {
            //         left: clampedStartDays * dayWidth,
            //         width: Math.max(dayWidth, (clampedEndDays - clampedStartDays) * dayWidth)
            //     };
            // };
            const getReservationPosition = (reservation) => {
                if (!reservation || !reservation.checkIn || !reservation.checkOut) {
                    return { left: -9999, width: 0 };
                }
                
                const startDays = getDaysFromStart(reservation.checkIn);
                const endDays = getDaysFromStart(reservation.checkOut);
                
                // If completely outside view, hide it
                if (endDays < 0 || startDays >= dates.length) {
                    return { left: -9999, width: 0 };
                }
                
                const visibleStartDays = Math.max(0, startDays);
                const visibleEndDays = Math.min(endDays, dates.length);
                
                return {
                    left: visibleStartDays * dayWidth,
                    width: (visibleEndDays - visibleStartDays) * dayWidth
                };
            };
            // const getReservationPosition = (reservation) => {
            //     const viewStart = dates[0];
            //     const viewEnd = dates[dates.length - 1];
                
            //     // Clamp reservation dates to current view period
            //     const displayStart = new Date(Math.max(reservation.checkIn.getTime(), viewStart.getTime()));
            //     const displayEnd = new Date(Math.min(reservation.checkOut.getTime(), viewEnd.getTime()));
                
            //     const startDays = filters.viewType ==='month' ? getDaysFromStart(displayStart)+1: getDaysFromStart(displayStart); // +1 because check-in is inclusive
            //     const endDays = filters.viewType ==='month' ? getDaysFromStart(displayEnd)+1:  getDaysFromStart(displayEnd) ; // +1 because checkout is exclusive
            //     // if(filters.viewType === 'month'){
            //     //     return {
            //     //     left: Math.max(0, startDays * dayWidth)+1,
            //     //     width: Math.max(dayWidth, (endDays - startDays) * dayWidth)
            //     // }
            //     // }
                
            //     return {
            //         left: Math.max(0, startDays * dayWidth),
            //         width: Math.max(dayWidth, (endDays - startDays) * dayWidth)
            //     };
            // };
            useEffect(() => {
                
                    // Auto-scroll to current month in year view
                    const timelineContainer = document.querySelector('.timeline-container');
                    if (timelineContainer) {
                        const today = new Date();
                        const currentMonth = today.getMonth();
                        const currentDay = getDaysFromStart(today);
                        
                        if (currentDay >= 0) {
                            const scrollPosition = Math.max(0, currentDay * dayWidth - 300); // 300px offset to show some context
                            timelineContainer.scrollLeft = scrollPosition;
                        }
                    }
                
            }, [loading,view, filters.viewType]);

            const isDateToday = (date) => {
                return date.toDateString() === today.toDateString();
            };

            const filteredSites = sites.filter(site => {
                if (filters.siteType !== 'all' && site.type !== filters.siteType) return false;
                return true;
            });

            // const calculateKPIs = () => {
            //     const totalSites = filteredSites.length;
            //     const totalDays = dates.length;
            //     const totalPossibleNights = totalSites * totalDays;
                
            //     let occupiedNights = 0;
            //     let totalRevenue = 0;
                
            //     reservations.forEach(reservation => {
            //         const site = sites.find(s => s.id === reservation.siteId);
            //         if (!site || !filteredSites.includes(site)) return;
                    
            //         const checkIn = Math.max(0, getDaysFromStart(reservation.checkIn));
            //         const checkOut = Math.min(dates.length, getDaysFromStart(reservation.checkOut));
                    
            //         if (checkOut > checkIn) {
            //             occupiedNights += (checkOut - checkIn);
            //             totalRevenue += reservation.totalAmount;
            //         }
            //     });
                
            //     const occupancyRate = totalPossibleNights > 0 ? (occupiedNights / totalPossibleNights) * 100 : 0;
                
            //     return { occupancyRate: occupancyRate.toFixed(1), revenue: totalRevenue };
            // };

            // const kpis = calculateKPIs();

            const getSiteFromPosition = (clientX, clientY) => {
                if (!calendarRef.current) return null;
                
                const rect = calendarRef.current.getBoundingClientRect();
                const relativeY = clientY - rect.top;
                const headerHeight = 120;
                const contentY = relativeY - headerHeight;
                
                if (contentY < 0) return null;
                
                const siteIndex = Math.floor(contentY / rowHeight);
                return filteredSites[siteIndex] || null;
            };

            const handleMouseDown = (e, reservationId, dragType) => {
                if (filters.viewType === 'month') {
                    return; // Exit early, no drag allowed
                }
                e.preventDefault();
                e.stopPropagation();
                
                const reservation = reservations.find(r => r.id === reservationId);
                if (!reservation) return;

                setDragState({
                    isDragging: true,
                    reservationId,
                    dragType,
                    startX: e.clientX,
                    startY: e.clientY,
                    originalReservation: { ...reservation },
                    targetSiteId: reservation.siteId
                });
            };

            const checkReservationConflict = (newReservation, excludeId) => {
                return reservations.some(existingReservation => {
                    if (existingReservation.id === excludeId) return false;
                    if (existingReservation.siteId !== newReservation.siteId) return false;
                    
                    const existingStart = getDaysFromStart(existingReservation.checkIn);
                    const existingEnd = getDaysFromStart(existingReservation.checkOut);
                    const newStart = getDaysFromStart(newReservation.checkIn);
                    const newEnd = getDaysFromStart(newReservation.checkOut);
                    
                    return (newStart < existingEnd && newEnd > existingStart);
                });
            };   

            const handleHorizontalScroll = (direction) => {
                const timelineContainer = document.querySelector('.timeline-container');
                if (timelineContainer) {
                    const scrollAmount = dayWidth * 7; // Scroll by 7 days worth
                    const currentScroll = timelineContainer.scrollLeft;
                    const newScroll = direction === 'left' 
                        ? Math.max(0, currentScroll - scrollAmount)
                        : currentScroll + scrollAmount;
                    
                    timelineContainer.scrollTo({
                        left: newScroll,
                        behavior: 'smooth'
                    });
                }
            };

            const handleMouseMove = useCallback((e) => {
                if (!dragState.isDragging) return;

                const deltaX = e.clientX - dragState.startX;
                const deltaDays = Math.round(deltaX / dayWidth);
                
                const targetSite = getSiteFromPosition(e.clientX, e.clientY);
                const targetSiteId = targetSite ? targetSite.id : dragState.originalReservation.siteId;
                
                const original = dragState.originalReservation;

                if (dragState.dragType === 'move') {
                    const originalStartDays = getDaysFromStart(original.checkIn);
                    const originalEndDays = getDaysFromStart(original.checkOut);
                    const duration = originalEndDays - originalStartDays;
                    const newStartDays = Math.max(0, originalStartDays + deltaDays);
                    
                    const proposedReservation = {
                        ...original,
                        siteId: targetSiteId,
                        checkIn: getDateFromDays(newStartDays),
                        checkOut: getDateFromDays(newStartDays + duration)
                    };

                    const hasConflict = checkReservationConflict(proposedReservation, dragState.reservationId);
                    
                    setConflictState({ hasConflict, message: hasConflict ? 'Cannot move here - dates conflict with existing reservation' : '' });
                    
                    // Clear visual state immediately when conflict occurs
                    if (hasConflict) {
                        setVisualDragState({
                            draggedReservationId: null,  // Clear this too
                            visualPosition: null
                        });
                    } else {
                        setVisualDragState({
                            draggedReservationId: dragState.reservationId,
                            visualPosition: proposedReservation
                        });
                    }
                } else if (dragState.dragType === 'resize-end') {
                    const originalEndDays = getDaysFromStart(original.checkOut);
                    const newEndDays = Math.max(getDaysFromStart(original.checkIn) + 1, originalEndDays + deltaDays);
                    
                    const proposedReservation = {
                        ...original,
                        checkOut: getDateFromDays(newEndDays)
                    };
                    
                    const hasConflict = checkReservationConflict(proposedReservation, dragState.reservationId);
                    
                    setConflictState({ hasConflict, message: hasConflict ? 'Cannot extend - would conflict with existing reservation' : '' });
                    
                    if (hasConflict) {
                        setVisualDragState({
                            draggedReservationId: null,
                            visualPosition: null
                        });
                        setReservations(prevReservations => 
                            prevReservations.map(reservation => {
                                if (reservation.id !== dragState.reservationId) return reservation;
                                return {...proposedReservation, checkOut: original.checkOut}; // revert to original end date
                            })
                        );
                    } else {
                        setVisualDragState({
                            draggedReservationId: dragState.reservationId,
                            visualPosition: proposedReservation
                        });
                        
                        // Update actual reservations state when no conflict
                        setReservations(prevReservations => 
                            prevReservations.map(reservation => {
                                if (reservation.id !== dragState.reservationId) return reservation;
                                return proposedReservation;
                            })
                        );
                    }
                }

                setDragState(prev => ({ ...prev, targetSiteId }));
            }, [dragState, dayWidth, reservations, getDaysFromStart, getDateFromDays, checkReservationConflict]);
            const handleMouseUp = useCallback(() => {
                if (dragState.isDragging && dragState.originalReservation) {
                    if (conflictState.hasConflict) {
                        setVisualDragState({ draggedReservationId: null, visualPosition: null });
                        setDragState({
                            isDragging: false,
                            reservationId: null,
                            dragType: null,
                            startX: 0,
                            startY: 0,
                            originalReservation: null,
                            targetSiteId: null
                        });
                        setModals({...modals, conflict: true});
                    } else if (visualDragState.visualPosition) {
                        setModals(prev => ({
                            ...prev,
                            changeConfirmation: {
                                reservationId: dragState.reservationId,
                                before: dragState.originalReservation,
                                after: visualDragState.visualPosition
                            }
                        }));
                    }
                }

                // ALWAYS clear drag states, regardless of modal status
                setConflictState({ hasConflict: false, message: '' });
                setVisualDragState({ draggedReservationId: null, visualPosition: null });
                setDragState({
                    isDragging: false,
                    reservationId: null,
                    dragType: null,
                    startX: 0,
                    startY: 0,
                    originalReservation: null,
                    targetSiteId: null
                });
            }, [dragState, conflictState, visualDragState]);
            const location = useLocation();
  const params = QueryString.parse(location.search);
  const serverName = params.serverName;


            useEffect(() => {
                if (dragState.isDragging) {
                    document.addEventListener('mousemove', handleMouseMove);
                    document.addEventListener('mouseup', handleMouseUp);
                    document.body.style.cursor = 'grabbing';
                    document.body.style.userSelect = 'none';
                    
                    return () => {
                        document.removeEventListener('mousemove', handleMouseMove);
                        document.removeEventListener('mouseup', handleMouseUp);
                        document.body.style.cursor = '';
                        document.body.style.userSelect = '';
                    };
                }
            }, [dragState.isDragging, handleMouseMove, handleMouseUp]);

            const getStatusColor = (status) => {
                switch (status) {
                    case 'confirmed': return '#26A69A';
                    case 'checked-in': return '#D32F2F';
                    case 'checked-out': return '#BDBDBD';
                    case 'cancelled': return '#BDBDBD';
                    case 'overstay': return '#6A1B9A';
                    case 'not-checked-in': return '#FEAE00';
                    case 'on-hold': return 'repeating-linear-gradient(45deg, #9E9E9E, #9E9E9E 2px, white 2px, white 4px)';
                    default: return '#BDBDBD';
                }
            };

            const EditReservationModal = ({ reservation, onClose, onSave }) => {
                console.log(reservation);
                const day = String(reservation.checkIn.getDate()).padStart(2, "0");
                const month = String(reservation.checkIn.getMonth() + 1).padStart(2, "0");
                const year = String(reservation.checkIn.getFullYear()).slice(-4);
                
                return (
                    <div className="modal-overlay">
                        <div className="modal-content edit-reservation-modal">
                            <div className="modal-header">
                                <h2>Reservation Details- {reservation?.id}</h2>
                                <button onClick={onClose} className="close-button">
                                    <X size={20} />
                                </button>
                            </div>
                            <div class="modal-body notification-body">
                                <div class="reservation-details">
                                    <div class="detail-item">
                                        <label className='label-class'>Guest Name:</label>
                                        <span className='span-class' id="guest-name">{reservation.guestName}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label className='label-class'>Reservation Number:</label>
                                        <span className='span-class' id="reservation-number">{reservation?.id}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label className='label-class'>Price:</label>
                                        <span className='span-class' id="reservation-price">${reservation.totalAmount}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label className='label-class'>Reservation Length:</label>
                                        <span className='span-class' id="reservation-length">
                                            {formatLocalDate(reservation.checkIn)} - {formatLocalDate(reservation.checkOut)}
                                        </span>
                                    </div>
                                    <div class="detail-item">
                                        <label className='label-class'>Number of Guests:</label>
                                        <span className='span-class' id="guest-count">
                                            {reservation?.adults} adults, {reservation?.children} child, {reservation?.pets} pet
                                        </span>
                                    </div>
                                </div>
                                <div class="modal-actions">
                                    {/* <a href = {`/reservation?serverName=${serverName}&reservationId=${reservation.id}`} target="_blank" class="edit-link">
                                        View Reservation
                                    </a> */}
                                    <button onClick={()=>setView(true)} class="edit-link">
                                        View Reservation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            };


            const ChangeConfirmationModal = ({ change, onConfirm, onCancel }) => {
                if (!change) return null;

                const beforeSite = sites.find(s => s.id === change.before.siteId);
                const afterSite = sites.find(s => s.id === change.after.siteId);

                const handleConfirm = async () => {
                    try {
                        onConfirm();
                    } catch (error) {
                        console.error('Error updating reservation:', error);
                        onConfirm(); // Close modal even if API fails
                    }
                };

                const handleCancel = () => {
                    onCancel();
                };

                const handleClose = () => {
                    onCancel();
                };

                return (
                    <div className="modal-overlay">
                        <div className="modal-content change-confirmation-modal">
                            <div className="modal-header">
                                <h2>Confirm Reservation Changes</h2>
                                <button onClick={handleClose} className="close-button">
                                    <X size={24} />
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="change-comparison">
                                    <div className="before-section">
                                        <h3>Before:</h3>
                                        <p>Site: {beforeSite?.name}</p>
                                        <p>Check In: {change.before.checkIn.toLocaleDateString()}</p>
                                        <p>Check Out: {change.before.checkOut.toLocaleDateString()}</p>
                                    </div>
                                    <div className="after-section">
                                        <h3>After:</h3>
                                        <p>Site: {afterSite?.name}</p>
                                        <p>Check In: {change.after.checkIn.toLocaleDateString()}</p>
                                        <p>Check Out: {change.after.checkOut.toLocaleDateString()}</p>
                                    </div>
                                </div>
                                <div className="modal-actions">
                                    <button onClick={handleCancel} className="cancel-button">Cancel</button>
                                    <button onClick={handleConfirm} className="confirm-button">Confirm Changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            };

            const generateMonthHeaders = () => {
                const monthHeaders = [];
                let currentMonth = null;
                let monthStart = 0;
                let monthWidth = 0;
                
                dates.forEach((date, index) => {
                    const month = date.getMonth();
                    const year = date.getFullYear();
                    const monthKey = `${year}-${month}`;
                    
                    if (currentMonth !== monthKey) {
                        if (currentMonth !== null) {
                            monthHeaders.push(
                                <div
                                    key={currentMonth}
                                    className="month-header"
                                    style={{
                                        left: monthStart * dayWidth,
                                        width: monthWidth * dayWidth
                                    }}
                                >
                                    {new Date(parseInt(currentMonth.split('-')[0]), parseInt(currentMonth.split('-')[1])).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                                </div>
                            );
                        }
                        currentMonth = monthKey;
                        monthStart = index;
                        monthWidth = 1;
                    } else {
                        monthWidth++;
                    }
                });
                
                if (currentMonth !== null) {
                    monthHeaders.push(
                        <div
                            key={currentMonth}
                            className="month-header"
                            style={{
                                left: monthStart * dayWidth,
                                width: monthWidth * dayWidth
                            }}
                        >
                            {new Date(parseInt(currentMonth.split('-')[0]), parseInt(currentMonth.split('-')[1])).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                        </div>
                    );
                }
                
                return monthHeaders;
            };
            if (loading) {
                return <CircularProgress style={{ marginTop: '20%', color:'#2dcd7a' }} />;
            }
            if(view){
                return <View serverName={serverName} reservationId={modals.editReservation.id} goBack={()=>{setView(false);setModals({...modals, editReservation:null})}} updateReservation={()=>{setUpdate(true) }}/>
            }

            return (
                <div className="campground-calendar">
                    <div className="header">
                        <div style={{ display: 'flex', justifyContent:'space-between'}}>
                            <h1>Site Availability Calendar</h1>
                            <button style={{height:'5%'}} onClick={onClose} className="instant-book-button">
                                ←
                                Go Back
                            </button>
                        </div>
                        
                        <div className="kpi-and-legend-section">
                            <div className="kpi-section">
                                <div className="kpi-item">
                                    <span>Occupancy Rate(YTD):</span>
                                    <span className="kpi-value">{kpi.occupancyRate}%</span>
                                </div>
                                <div className="kpi-item">
                                    <span>Revenue(YTD):</span>
                                    <span className="kpi-value">${kpi.totalRevenue}</span>
                                </div>
                            </div>
                            
                            <div className="legend">
                                <div className="legend-item">
                                    <div className="legend-color occupied"></div>
                                    <span>Occupied</span>
                                </div>
                                <div className="legend-item">
                                    <div className="legend-color reserved"></div>
                                    <span>Reserved</span>
                                </div>
                                <div className="legend-item">
                                    <div className="legend-color not-checked-in"></div>
                                    <span>Not Checked In</span>
                                </div>
                                <div className="legend-item">
                                    <div className="legend-color unavailable"></div>
                                    <span>Unavailable</span>
                                </div>
                                <div className="legend-item">
                                    <div className="legend-color overstay"></div>
                                    <span>Overstay</span>
                                </div>
                                <div className="legend-item">
                                    <div className="legend-color on-hold"></div>
                                    <span>In Review</span>
                                </div>
                            </div>
                        </div>

                        <div className="controls">
                            <select
                                value={filters.siteType}
                                onChange={(e) => setFilters({...filters, siteType: e.target.value})}
                                className="filter-select"
                            >
                                <option value="all">All Site Types</option>
                                {siteTypes.map((type)=> (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                                {/* <option value="all">All Site Types</option>
                                <option value="Full Hookup">Full Hookup</option>
                                <option value="Electric Only">Electric Only</option>
                                <option value="Primitive">Primitive</option> */}
                            </select>
                            
                            <div className="view-type-selector">
                                {/* <button
                                    onClick={() => setFilters({...filters, viewType: 'day'})}
                                    className={`view-button ${filters.viewType === 'day' ? 'active' : ''}`}
                                >
                                    Day
                                </button>
                                <button
                                    onClick={() => setFilters({...filters, viewType: 'week'})}
                                    className={`view-button ${filters.viewType === 'week' ? 'active' : ''}`}
                                >
                                    Week
                                </button> */}
                                <button
                                    onClick={() => setFilters({...filters, viewType: 'month'})}
                                    className={`view-button ${filters.viewType === 'month' ? 'active' : ''}`}
                                >
                                    Month
                                </button>
                                <button
                                    onClick={() => setFilters({...filters, viewType: 'year'})}
                                    className={`view-button ${filters.viewType === 'year' ? 'active' : ''}`}
                                >
                                    Year
                                </button>
                            </div>
                            
                            {/* <div className="date-navigation">
                                <button
                                    onClick={() => {
                                        const newDate = new Date(filters.currentDate);
                                        switch (filters.viewType) {
                                            case 'day':
                                                newDate.setDate(newDate.getDate() - 1);
                                                break;
                                            case 'week':
                                                newDate.setDate(newDate.getDate() - 7);
                                                break;
                                            case 'month':
                                                newDate.setMonth(newDate.getMonth() - 1);
                                                break;
                                            case 'year':
                                                newDate.setFullYear(newDate.getFullYear() - 1);
                                                break;
                                        }
                                        setFilters({...filters, currentDate: newDate});
                                    }}
                                    className="nav-button"
                                >
                                    ←
                                </button>
                                <span className="current-period">
                                    {filters.viewType === 'year' 
                                        ? filters.currentDate.getFullYear()
                                        : filters.viewType === 'month'
                                        ? filters.currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                                        : filters.viewType === 'week'
                                        ? `Week of ${filters.currentDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
                                        : filters.currentDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
                                    }
                                </span>
                                <button
                                    onClick={() => {
                                        const newDate = new Date(filters.currentDate);
                                        switch (filters.viewType) {
                                            case 'day':
                                                newDate.setDate(newDate.getDate() + 1);
                                                break;
                                            case 'week':
                                                newDate.setDate(newDate.getDate() + 7);
                                                break;
                                            case 'month':
                                                newDate.setMonth(newDate.getMonth() + 1);
                                                break;
                                            case 'year':
                                                newDate.setFullYear(newDate.getFullYear() + 1);
                                                break;
                                        }
                                        setFilters({...filters, currentDate: newDate});
                                    }}
                                    className="nav-button"
                                >
                                    →
                                </button>
                            </div> */}
                            <div className="date-navigation">
                                <button
                                    onClick={() => {
                                        const newDate = new Date(filters.currentDate);
                                        if (filters.viewType === 'month') {
                                            newDate.setMonth(newDate.getMonth() - 1);
                                        } else {
                                            newDate.setFullYear(newDate.getFullYear() - 1);
                                        }
                                        setFilters({...filters, currentDate: newDate});
                                    }}
                                    className="nav-button"
                                >
                                    ←
                                </button>
                                <span className="current-period">
                                    {filters.viewType === 'year' 
                                        ? filters.currentDate.getFullYear()
                                        : filters.currentDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
                                    }
                                </span>
                                <button
                                    onClick={() => {
                                        const newDate = new Date(filters.currentDate);
                                        if (filters.viewType === 'month') {
                                            newDate.setMonth(newDate.getMonth() + 1);
                                        } else {
                                            newDate.setFullYear(newDate.getFullYear() + 1);
                                        }
                                        setFilters({...filters, currentDate: newDate});
                                    }}
                                    className="nav-button"
                                >
                                    →
                                </button>
                            </div>
                            <button
                                onClick={() => setModals({...modals, instantBook: true})}
                                className="instant-book-button"
                            >
                                <Plus size={16} />
                                Instant Book
                            </button>
                        </div>
                    </div>

                    <div className="calendar-container" ref={calendarRef} style={{ position: 'relative' }}>
                        <div className="horizontal-scroll-controls" >
                            <button
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' , zIndex:'12', position:'absolute', top:'58px', left:'385px', transform:'translateY(-50%)'}}
                                onClick={() => handleHorizontalScroll('left')}
                                className="nav-button"
                                title="Scroll Left"
                            >
                                ⇐
                            </button>
                            <button
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' , zIndex:'12', position:'absolute', top:'58px', right:'35px', transform:'translateY(-50%)'}}
                                onClick={() => handleHorizontalScroll('right')}
                                className="nav-button"
                                title="Scroll Right"
                            >
                                    ⇒
                            </button>
                        </div>
                        <div className="calendar-grid">
                            <div className="fixed-columns">
                                <div className="column-headers">
                                    <div className="column-header site-header">Site/Space</div>
                                    <div className="column-header rate-header">Avg Rate</div>
                                </div>
                                
                                {filteredSites.map((site) => (
                                    <div key={site.id} className="site-row-fixed">
                                        <div className="site-info">
                                            <div className="site-name">{site.name}</div>
                                            <div className="site-type">{site.type}</div>
                                        </div>
                                        <div className="rate-info">${site.avgPrice}</div>
                                    </div>
                                ))}
                            </div>
                            
                            <div className="timeline-container">
                                <div className="timeline-header">
                                    <div className="month-header-row">
                                        {generateMonthHeaders()}
                                    </div>
                                    
                                    <div className="date-header-row">
                                        {dates.map((date, index) => (
                                            <div
                                                key={index}
                                                className={`date-cell ${isDateToday(date) ? 'today' : ''}`}
                                            >
                                                <div className="date-day">{date.getDate()}</div>
                                                {(filters.viewType === 'week' || filters.viewType === 'day') && (
                                                    <div className="date-weekday">
                                                        {date.toLocaleDateString('en-US', { weekday: 'short' })}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className="timeline-content">
                                    {filteredSites.map((site, siteIndex) => {
                                        const siteReservations = reservations.filter(r => r.siteId === site.id && isReservationInCurrentPeriod(r));
                                        
                                        // Add the dragged reservation if it's being moved to this site (and no conflict)
                                        const displayReservations = [...siteReservations];
                                        if (visualDragState.draggedReservationId && 
                                            visualDragState.visualPosition && 
                                            visualDragState.visualPosition.siteId === site.id &&
                                            !conflictState.hasConflict) {
                                            
                                            const originalReservation = reservations.find(r => r.id === visualDragState.draggedReservationId);
                                            // Only add if it's not originally from this site (cross-site move)
                                            if (originalReservation && originalReservation.siteId !== site.id) {
                                                displayReservations.push({
                                                    ...originalReservation,
                                                    ...visualDragState.visualPosition
                                                });
                                            }
                                        }
                                        
                                        return (
                                            <div key={site.id} className="site-row-timeline">
                                                <div className="reservation-timeline" style={{ width: dates.length * dayWidth }}>
                                                    {dates.map((date, i) => (
                                                        <div
                                                            key={i}
                                                            className={`date-column ${isDateToday(date) ? 'today-column' : ''}`}
                                                            style={{ left: i * dayWidth }}
                                                        />
                                                    ))}
                                                    
                                                    {displayReservations.map((reservation) => {
                                                        // Hide original reservation if it's being dragged to another site (and no conflict)
                                                        const shouldHideOriginal = visualDragState.draggedReservationId === reservation.id && 
                                                                                visualDragState.visualPosition && 
                                                                                visualDragState.visualPosition.siteId !== reservation.siteId &&
                                                                                !conflictState.hasConflict;
                                                        
                                                        if (shouldHideOriginal) return null;

                                                        // Use visual position only if no conflict
                                                        let displayReservation = reservation;
                                                        if (visualDragState.draggedReservationId === reservation.id) {
                                                            if (visualDragState.visualPosition && !conflictState.hasConflict) {
                                                                displayReservation = visualDragState.visualPosition;
                                                            }
                                                        }
                                                        
                                                        const position = getReservationPosition(displayReservation);
                                                        const isDragging = dragState.isDragging && dragState.reservationId === reservation.id;
                                                        
                                                        return (
                                                            <div
                                                                key={`${reservation.id}-${displayReservation.siteId}`}
                                                                className={`reservation-block ${isDragging ? 'dragging' : ''}`}
                                                                style={{
                                                                    left: Math.max(0, position.left),
                                                                    width: Math.max(dayWidth, position.width),
                                                                    background: reservation.status === 'on-hold' ? getStatusColor(reservation.status) : 'none',
                                                                    backgroundColor: reservation.status !== 'on-hold' ? getStatusColor(reservation.status) : 'transparent',
                                                                    cursor: filters.viewType === 'year' ? 'grab' : 'pointer'
                                                                }}
                                                                onClick={() => setModals({...modals, editReservation: reservation})}
                                                                onMouseDown={(e) => handleMouseDown(e, reservation.id, 'move')}
                                                            >
                                                                <div className="reservation-content">
                                                                    <div className="reservation-id" style={{color: reservation.status === 'on-hold' ? 'black' : 'white', fontSize: reservation.status === 'on-hold' ?'1rem':'0.75rem', fontWeight: reservation.status === 'on-hold' ?'900':'700'}}>{reservation.id}</div>
                                                                    <div className="guest-name" style={{color: reservation.status === 'on-hold' ? 'black' : 'white', fontSize: reservation.status === 'on-hold' ?'1rem':'0.75rem', fontWeight: reservation.status === 'on-hold' ?'900':'700'}}>{reservation.guestName}</div>
                                                                </div>
                                                                {filters.viewType === 'year' && (<div
                                                                    className="resize-handle"
                                                                    onMouseDown={(e) => {
                                                                        e.stopPropagation();
                                                                        handleMouseDown(e, reservation.id, 'resize-end');
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                />)}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                    {modals.editReservation && (
                        <EditReservationModal
                            reservation={modals.editReservation}
                            onClose={() => setModals({...modals, editReservation: null})}
                            onSave={(formData) => {
                                setModals({...modals, editReservation: null});
                            }}
                        />
                    )}

                    {modals.instantBook && (
                        <InstantBookModal
                            onClose={() => setModals({...modals, instantBook: false})}
                            onSave={(formData, message, reservationId, cost) => {
                                console.log(formData, message, reservationId, cost);
                                
                                setReservations(prev => [...prev, { guestName: formData.firstName+formData.lastName, id: reservationId, checkIn: new Date(formData.startDate), checkOut: new Date(formData.endDate), siteId:  parseInt(formData.space), status: 'confirmed', totalAmount: cost }]);
                                setModals({...modals, instantBook: false, notification: true, message: message, reservationData: { ...formData, id: reservationId }});
                            }}
                        />
                    )}

                    {modals.notification && (
                        <NotificationModal
                            type={modals.message}
                            reservationData={modals.reservationData}
                            onClose={() => setModals({...modals, notification: false})}
                        />
                    )}
                    {modals.conflict && (
                        <ReservationConflictnModal
                            onClose={() => setModals({...modals, conflict: false})}
                        />
                    )}

                    {modals.changeConfirmation && (
                        <ChangeConfirmationModal
                            change={modals.changeConfirmation}
                            onConfirm={async () => {
                                const afterOrg = modals.changeConfirmation.after;
                                const newCheckIn = formatLocalDate(afterOrg.checkIn);
                                const newCheckOut = formatLocalDate(afterOrg.checkOut);
                                await updateReservationDateSite(serverName,
                                    modals.changeConfirmation.reservationId,
                                    newCheckIn,newCheckOut,afterOrg.siteId
                                );
                                setReservations(prev => prev.map(r =>
                                    r.id === modals.changeConfirmation.reservationId
                                        ? { ...r, checkIn: afterOrg.checkIn, checkOut: afterOrg.checkOut, siteId: afterOrg.siteId }
                                        : r
                                ));
                                setVisualDragState({ draggedReservationId: null, visualPosition: null });
                                setModals({...modals, changeConfirmation: null});
                            }}
                            onCancel={() => {
                            const original = modals.changeConfirmation.before;
                            setReservations(prev => prev.map(r =>
                                r.id === modals.changeConfirmation.reservationId
                                    ? { ...r, checkIn: original.checkIn, checkOut: original.checkOut, siteId: original.siteId }
                                    : r
                            ));
                            setVisualDragState({ draggedReservationId: null, visualPosition: null });
                            setModals({...modals, changeConfirmation: null, editReservation: null});
                        }}
                        />
                    )}
                </div>
            );
        };
        export default CampgroundCalendar;